import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25b6721c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "server-selection-root" }
const _hoisted_2 = {
  action: "",
  class: "form"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\" data-v-25b6721c></div><h3 class=\"form-title\" data-v-25b6721c>线路选择</h3><p class=\"p1\" data-v-25b6721c> 线路为绿色 <span class=\"icon-check\" data-v-25b6721c></span>可直接点击进入，红色 <span class=\"icon-x\" data-v-25b6721c></span> 代表该线路不可用， </p><p class=\"p2\" data-v-25b6721c> 如三个线路均不可用，请联系在线客服获取更多线路，并输入所获取的线路地址点击进入，即可游戏，祝您游戏愉快。 </p>", 4)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "btn-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-label" }, "线路一", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-label" }, "线路二", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-label" }, "线路三", -1))
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-label" }, "进入", -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { disabled: !_ctx.line1 }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickLine(1)))
          }, [
            _hoisted_9,
            _createElementVNode("div", {
              class: _normalizeClass(["btn-icon", _ctx.line1 ? 'icon-check' : 'icon-x'])
            }, null, 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { disabled: !_ctx.line2 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickLine(2)))
          }, [
            _hoisted_10,
            _createElementVNode("div", {
              class: _normalizeClass(["btn-icon", _ctx.line2 ? 'icon-check' : 'icon-x'])
            }, null, 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { disabled: !_ctx.line3 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickLine(3)))
          }, [
            _hoisted_11,
            _createElementVNode("div", {
              class: _normalizeClass(["btn-icon", _ctx.line3 ? 'icon-check' : 'icon-x'])
            }, null, 2)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "自定义线路",
            class: "input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.serverStr) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.serverStr,
              void 0,
              { trim: true }
            ]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["btn", { disabled: _ctx.serverStr.length <= 0 }]),
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.enterLogin && _ctx.enterLogin(...args)))
          }, _hoisted_14, 2)
        ])
      ])
    ])
  ]))
}